import { FontIcon } from '@fluentui/react';
import { FC } from 'react';
import styled from 'styled-components';

const RotatingFontIcon = styled(FontIcon)`
  transition: transform 300ms ease;
  cursor: pointer;
  user-select: none;
  color: ${p => p.theme.palette.themePrimary};
`;

interface IProps {
  direction: 'left' | 'right';
  isExpanded: boolean;
  onClick?(): void;
}

const ExpanderButton: FC<IProps> = ({ direction, isExpanded, onClick }) => (
  <RotatingFontIcon
    iconName={direction === 'left' ? 'ChevronLeftMed' : 'ChevronRightMed'}
    onClick={onClick}
    style={{ transform: isExpanded ? (direction === 'left' ? 'rotate(-90deg)' : 'rotate(90deg)') : undefined }}
  />
);

export default ExpanderButton;